import { ReactNode } from 'react';

type Title = {
  title: string | undefined;
  subTitle?: string | undefined;
  additionalComponent?: ReactNode;
};

const Title = ({ title, subTitle, additionalComponent }: Title) => {
  return (
    <div className="flex flex-row justify-start pt-10 sm:justify-center [] lg:mb-0 lg:pt-16 xl:pt-16">
      <div className="flex flex-col text-left md:text-left lg:text-center xl:text-center">
        <div
          className={`flex justify-start md:justify-center items-center ${
            subTitle && 'pb-4'
          }`}
        >
          {additionalComponent && (
            <div className="mr-2">{additionalComponent}</div>
          )}
          <h3 className="text-left md:text-center font-semibold text-3xl leading-9 tracking-wide">
            {title}
          </h3>
        </div>
        {subTitle && (
          <div className="text-left md:text-center font-normal text-lg leading-6 tracking-wide text-body-text pb-10">
            {subTitle}
          </div>
        )}
      </div>
    </div>
  );
};

export default Title;
